export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdzenie"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czy na pewno chcesz kontynuować?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń kryptoaktywo"])}
}